<template>
	<div class="form-inputs">
		<FormLabelTooltip
			v-if="label"
			:required="required"
			:name="name"
			:label="label"
			:tooltip="tooltip"
		/>
		<input
			ref="baseFormInput"
			class="b360-form-input"
			:class="{ error: error, 'input-icon-after': icon }"
			:id="name"
			:type="type"
			:placeholder="placeholder"
			:required="required"
			:inputMask="inputMask"
			:disabled="disabled"
			v-model="inputVal"
			@focus="handleInputFocus"
			@blur="handleInputBlur"
			@input="validateInputCharacters($event)"
		/>
		<button
			class="input-icon-button"
			v-if="icon"
			@click="onIconClick($event)"
			:aria-label="iconLabel"
			:disabled="disabled"
		>
			<font-awesome-icon class="input-icon" :icon="icon" />
		</button>
	</div>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'BaseFormInput',
	components: {
		FormLabelTooltip,
	},
	props: {
		disabled: Boolean,
		error: Boolean,
		icon: Array,
		iconLabel: {
			type: String,
			default: '',
		},
		label: String,
		name: String,
		placeholder: String,
		required: Boolean,
		inputMask: RegExp,
		tooltip: String,
		type: String,
		value: String,
	},
	data() {
		return {
			inputVal: this.value,
		};
	},
	methods: {
		onIconClick(event) {
			event.preventDefault();
			this.$emit('onIconClick');
			this.$nextTick(() => {
				this.$refs.baseFormInput.focus();
			});
		},
		validateInputCharacters(event) {
			if (this.inputMask && this.inputMask.test(event.key)) {
				event.preventDefault();
			}
		},
		handleInputFocus() {
			this.$emit('onFocus', this.$refs.baseFormInput);
		},
		handleInputBlur() {
			this.$emit('onBlur');
		},
	},
	watch: {
		inputVal(value) {
			this.$emit('input', value);
			this.inputVal = value.replace(this.inputMask, '');
		},
		value(value) {
			this.inputVal = value;
		},
	},
};
</script>

<style scoped lang="scss">
.form-inputs {
	position: relative;
}

.input-icon-after {
	@include rem(padding-right, 32px);
}

.input-icon-button {
	position: absolute;
	right: 1px;
	top: 2px;
	display: flex;
	justify-content: center;
	align-items: center;
	@include rem(width, 32px);
	@include rem(height, 42px);
	border: none;
	border-radius: $b360-border-radius-base;
	background: transparent;
	cursor: pointer;

	.input-icon {
		color: $b360-color--blue;
	}

	&:disabled .input-icon {
		cursor: not-allowed;
		color: $b360-color--gray__darkest;
	}
}

.error {
	border-color: $error;
}
</style>
